import { Formik, FieldArray } from 'formik'
import React from 'react'
import { useSelector } from 'react-redux'
import { Input } from 'formik-antd'
import { RootState } from '../../../../../../model/rootReducer'
import { updateEventFormList } from '../../../../../../helpers/monitoringGraphHelper'
import { StyledForm, CheckboxGroup, StyledCheckbox, Button } from '../../Styled'
type FormProps = {
  generatePath: (selectedFilters: Object) => void
  setConversationId: (conversationId: string) => void
}
const PathGenerationForm: React.FunctionComponent<FormProps> = ({
  generatePath,
  setConversationId,
}) => {
  const pathData = useSelector((state: RootState) => state.monitoringGraph.path)
  const initialValues = {
    events: [],
    conversationId: pathData.conversationsId[0],
  }
  const events = useSelector((state: RootState) => state.monitoringGraph.events)
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={(values) => {
        generatePath(values)
        setConversationId(values.conversationId)
      }}
      render={({}) => (
        <StyledForm>
          <Input
            name="conversationId"
            placeholder="conversation Id"
            required
            allowClear
            defaultValue={pathData.conversationsId}
          ></Input>
          <FieldArray
            name="events"
            render={(arrayHelpers) => (
              <CheckboxGroup>
                {events.map((filter, index) => (
                  <div key={index}>
                    <StyledCheckbox
                      onClick={(event) =>
                        updateEventFormList(event, arrayHelpers, filter.name)
                      }
                      name={filter.name}
                    >
                      {filter.name}
                    </StyledCheckbox>
                  </div>
                ))}
              </CheckboxGroup>
            )}
          />
          <Button name="submit" loading={false}>
            Générer
          </Button>
        </StyledForm>
      )}
    />
  )
}
export default PathGenerationForm
